module.exports = ".reset-ul {\n  margin: 0 0 1rem 0;\n  list-style: none; }\n  .reset-ul li {\n    margin-bottom: 0.5rem; }\n  .preferenceAnimation_label {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex; }\n  .preferenceAnimation_label input {\n    margin: 0 1rem 0 0;\n    height: 20px;\n    width: 20px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/screens/form-voluntary/form-voluntary.component.scss
// module id = ./src/app/screens/form-voluntary/form-voluntary.component.scss
// module chunks = main